module.exports = __webpack_public_path__ + "img/sublime-save-as.jpg_w545.25ea8674.jpg";